<div  mat-dialog-title>Update Confirmation
  <div class="dialog-close-button">
      <a (click)="onClose()" id="close">
          <img src="/assets/images/close-popup.png">
      </a>
  </div>
</div>
<div mat-dialog-content cdkFocusInitial>
  <span *ngIf="data.productDescription">
    {{data.itemCIN}} - {{data.productDescription}} has been added to your Watchlist. When this item is available for purchase, you will receive an email notification.
    <br><br>
    To stop email notifications, please remove the product from your Watchlist.
  </span>
</div>
<div mat-dialog-actions>
  <button mat-raised-button id="btn-confirm" [mat-dialog-close]="true">Go to my Watchlist</button>
  <button mat-raised-button [mat-dialog-close]="false" id="btn-cancel">Close</button>
</div>